import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 15:56:01
 * @LastEditTime: 2021-07-01 16:09:05
 * @LastEditors: wangshengqiang
 * @Description: 被保人信息确认
 */

/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { useStore } from '@/store';
import { isNotEmptyArray, isPreviewMode } from '@/utils';
import ConfirmInfoTitle from '../ConfirmOrderInfo/ConfirmInfoTitle';
import { DetailItem, transFormValue } from '../ConfirmOrderInfo/transformValue';
import './index.less';

const SortTitle = ({
  children
}) => {
  return /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: '18px',
      padding: '5px 13px 10px'
    }
  }, " ", children, " ");
}; // 是否有可选条款


const hasOptionalClause = ({
  packageList
} = {}) => {
  if (!isNotEmptyArray(packageList)) {
    return false;
  }

  return packageList.some(({
    productList
  } = {}) => {
    return isNotEmptyArray(productList) ? productList.some(item => item.isOptional === 'Y') : false;
  });
}; // 被保人信息确认


const InsurantInfoConfirm = props => {
  const {
    attrs,
    label
  } = props;
  const {
    dataSource = [],
    isDefault
  } = attrs;
  if (!isDefault) return null;
  const orderDetail = useStore('orderDetail') || {};
  let {
    insuredList
  } = orderDetail;

  if (!insuredList) {
    insuredList = [{}];
  } // 预览时候给个空被保人, 不然页面没有数据


  const enableList = isPreviewMode() ? [{}] : insuredList.filter(item => item.allowInsure !== false && item.selected === true);
  const Filter = dataSource.filter(item => item.isDefault === true);

  if (Filter.length === 0) {
    return null;
  } // 是否有保障计划


  const planIdIndex = Filter.findIndex(item => item.value === 'planId');
  const hasPlanSelect = planIdIndex > -1;
  const otherList = Filter.filter(item => item.label !== Filter[0].label); // 保障计划增加可选条款、保费

  if (hasPlanSelect) {
    const extraItems = [{
      dataSource: [{
        label: '投保',
        value: true
      }, {
        label: '不投保',
        value: false
      }],
      isDefault: true,
      label: '可选计划',
      value: 'optionalClause'
    }, {
      dataSource: [],
      isDefault: true,
      label: '保费',
      value: 'premium'
    }];
    otherList.splice(planIdIndex, 0, ...extraItems);
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "c-InfoConfirm bg-fff"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(ConfirmInfoTitle, {
    alt: "\u88AB\u4FDD\u4EBA",
    title: label
  })), enableList.map((item, index) => {
    var _Filter$;

    // 可选条款
    const optionalClause = hasOptionalClause(item); // 被保人数据

    const itemDetail = _objectSpread(_objectSpread({}, item.person || {}), hasPlanSelect ? {
      optionalClause
    } : {});

    return /*#__PURE__*/React.createElement(React.Fragment, null, (enableList === null || enableList === void 0 ? void 0 : enableList.length) > 1 && /*#__PURE__*/React.createElement(SortTitle, null, "\u88AB\u4FDD\u9669\u4EBA", index + 1), /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "item first"
    }, /*#__PURE__*/React.createElement("div", {
      className: "left"
    }, Filter[0].label, ":"), /*#__PURE__*/React.createElement("div", {
      className: "right"
    }, transFormValue(itemDetail[Filter[0].value], Filter[0].dataSource, (_Filter$ = Filter[0]) === null || _Filter$ === void 0 ? void 0 : _Filter$.value))), otherList.map(item1 => {
      return /*#__PURE__*/React.createElement(DetailItem, {
        itemValue: itemDetail[item1.value],
        dataSource: item1.dataSource,
        itemlabel: item1.label,
        itemKey: item1.value,
        key: item1.value
      });
    })));
  })));
};

export default InsurantInfoConfirm;